// ─── OUTPUT FORMATTERS ───────────────────────────────────────────────────────
// Pure functions that turn a history entry into text for a reader.
//
// getFullOutputTextForEntry(entry) → EVERY piece as plain text (publish/serialize/
//   plain.js :: piecesToPlain, one "=== label ===" per piece, no title) — what a
//   reader of the whole output gets (tenantAdmin RunDetailModal). It reads the
//   entry's PIECE LIST (src/publish/), never content.full_text. An entry the
//   piece builders decline (a cancelled run, an unreadable content) falls back
//   to the content as it is: a string content verbatim, an object content's
//   full_text / body, else that object as pretty-printed JSON. No content at
//   all is '' (the modal's empty state) — never the run's bookkeeping.
//
// History lives only in memory (store/initialState.js :: outputHistory; nothing
// persists or rehydrates it), so every entry has the shape useGeneration.js /
// admin RunDetailPage build (results.content). The pre-pipeline per-mode shapes
// (fullPost, slides, subjectLine, thread, case-study…) cannot reach this
// function and have no branch here.

import { piecesForEntry } from '../publish/pieces/index.js';
import { piecesToPlain } from '../publish/serialize/plain.js';

export function getFullOutputTextForEntry(entry) {
  const results = entry?.results;
  if (!results) return '';
  const pieces = piecesForEntry(entry);
  if (pieces.length) return piecesToPlain(pieces);
  // No pieces (a cancelled run, an unreadable content): the content as it is.
  // No content at all is '' — the reader shows its own empty state, never the
  // run's bookkeeping (ids, scores) as text.
  const c = results.content;
  if (c == null || c === '') return '';
  if (typeof c === 'string') return c;
  if (typeof c === 'object') return c.full_text || c.body || JSON.stringify(c, null, 2);
  return String(c);
}
